module.exports = __webpack_public_path__ + "static/media/cipia-logo-white.f4b9aab0.png";